<template>
  <div
    class="mt-8px flex cursor-pointer items-center justify-between text-primary-80"
    @click="isShrink = !isShrink"
  >
    <p class="title-12-h16-m">{{ name }}</p>
    <i class="icon-chevron-up text-24px duration-200" :class="{ 'rotate-180': isShrink }" />
  </div>
  <div
    class="flex-shrink-0 overflow-hidden duration-200 ease-in-out"
    :style="{ 'max-height': isShrink ? 0 : `${(viewData.length + 1) * INPUT_HEIGHT}px` }"
  >
    <div
      class="mt-8px flex flex-col gap-8px overflow-hidden duration-200 ease-out"
      :style="{ 'max-height': `${viewData.length * INPUT_HEIGHT}px` }"
    >
      <InputCheckbox
        v-for="(item, index) in viewData"
        :key="index"
        v-model:model-value="item.isChecked"
        :label="item.label"
        @update:model-value="updateValue(item.key, item.label)"
      />
    </div>
    <div
      v-if="!showExpandBtn && inputData.length > INPUT_DEFAULT_LENGTH"
      class="mt-8px flex cursor-pointer text-primary-60"
      @click="showExpandBtn = true"
    >
      <i class="icon-plus text-20px" />
      <p class="ml-8px content-11-h20-r">{{ $t('btn.see_more') }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'

import InputCheckbox from '@/components/InputCheckbox.vue'
import { type CheckboxGroupData } from '@/components/layout/CheckboxGroup.type'

const props = withDefaults(
  defineProps<{
    forceExpand?: boolean
    inputData: CheckboxGroupData[]
    name: string
  }>(),
  {
    forceExpand: false,
  },
)

const emit = defineEmits<{
  updateList: [key: string, label: string]
}>()

const isShrink = ref(false)
const INPUT_HEIGHT = 32
const INPUT_DEFAULT_LENGTH = 5
const showExpandBtn = ref(false)

onMounted(() => {
  if (props.forceExpand) showExpandBtn.value = true
})

const viewData = computed(() => {
  if (showExpandBtn.value) {
    return props.inputData
  }
  return props.inputData.slice(0, 5)
})
function updateValue(key: string, label: string): void {
  emit('updateList', key, label)
}
</script>
